module.exports = __webpack_public_path__ + "files/b3fc60adfc7f5727293e3dd3d8f116ab.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-18.png
// module id = 1507
// module chunks = 60